import * as React from 'react';
import { IStandardVideo } from '../../../../settings';
import * as styles from './VideoSlide.css';

interface ICarouselBannerProps {
  video: IStandardVideo;
}

export function VideoSlide(props: ICarouselBannerProps) {
  const { video } = props;

  if (!video.fullUrl) {
    return null;
  }

  return (
    <div className={styles['slide']}>
      <video controls autoPlay src={video.fullUrl} height="100%" width="100%" />
    </div>
  );
}
